import { lazy, Suspense } from "react"

import { buildHero } from "@/shared/i18n/legacyShape"
import { useLocaleCopy } from "@/shared/i18n/useLocaleCopy"

import {
  HeroActions,
  HeroBackground,
  HeroScrollHint,
  HeroTitle,
} from "./hero"
import { DeferredHeroOrb } from "./hero/DeferredHeroOrb"

const HeroFlowRotator = lazy(() =>
  import("./hero/HeroFlowRotator").then((m) => ({ default: m.HeroFlowRotator })),
)

const SECTION_ID = "inicio"
const SECTION_ARIA_LABEL = "Apresentação da MesaOTC"

function FlowRotatorFallback() {
  return (
    <div
      aria-hidden="true"
      className="h-24 w-full max-w-md rounded-2xl border border-mesa-border/60 bg-card/60 shadow-[0_1px_2px_rgba(11,26,59,0.04)] sm:w-80"
    />
  )
}

export function HeroSection() {
  const copy = useLocaleCopy()
  const HERO = buildHero(copy)
  return (
    <section
      id={SECTION_ID}
      aria-labelledby="hero-heading"
      aria-label={SECTION_ARIA_LABEL}
      className="relative isolate flex w-full flex-col overflow-hidden bg-mesa-bg lg:min-h-svh"
    >
      <HeroBackground />

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-6 pt-24 pb-16 md:px-10 md:pt-32 md:pb-14">
        <div className="grid w-full grid-cols-1 items-center gap-y-12 lg:grid-cols-12 lg:gap-x-16 lg:gap-y-10">
          <div
            id="hero-heading"
            className="flex flex-col items-center lg:col-span-7 lg:items-start"
          >
            <HeroTitle
              lineOne={HERO.titleLine1}
              lineTwoPrefix={HERO.titleLine2Prefix}
              lineTwoHighlight={HERO.titleLine2Highlight}
              description={HERO.description}
            />

            <div className="mt-7 w-full sm:w-auto md:mt-8">
              <Suspense fallback={<FlowRotatorFallback />}>
                <HeroFlowRotator />
              </Suspense>
            </div>

            <div className="mt-6 w-full sm:w-auto md:mt-8">
              <HeroActions
                primaryLabel={HERO.cta}
                primaryHref="#contato"
                secondaryLabel={HERO.ctaSecondary}
                secondaryHref="#api"
              />
            </div>
          </div>

          <div className="flex items-center justify-center lg:col-span-5">
            <DeferredHeroOrb />
          </div>
        </div>
      </div>

      <HeroScrollHint />
    </section>
  )
}
